import { CLIENT_API_URL, fmhAPI } from 'api/APIBase';

/** Get bids associated with a referral */
export async function getReferralBids({ referralId, payerId, auctionStart, auctionEnd }) {
    const url = `${CLIENT_API_URL}/admin/${payerId}/referrals/${referralId}/bids`;
    return fmhAPI.base
        .url(url)
        .query({ auction_start: auctionStart, auction_end: auctionEnd })
        .get()
        .json();
}

export async function getReferral(referralId, payerId) {
    const url = `${CLIENT_API_URL}/admin/${payerId}/referrals/${referralId}`;
    return fmhAPI.base
        .url(url)
        .get()
        .notFound(() => ({}))
        .json();
}

export async function getPendingReferral(referralId, payerId) {
    const url = `${CLIENT_API_URL}/admin/${payerId}/clinical/${referralId}`;
    return fmhAPI.base
        .url(url)
        .get()
        .notFound(() => ({}))
        .json();
}

/** Mimic submitting auth from the payer to our platform */
export async function submitReferral({ referralId, payerId, username, reason, source }) {
    const url = `${CLIENT_API_URL}/admin/${payerId}/clinical/${referralId}`;
    return fmhAPI.base
        .url(url)
        .query({ action: 'submit' })
        .post({ user_name: username, reason, source })
        .json();
}

/** Check the expected route for a referral */
export async function checkReferralRoute({ payerId, params }) {
    const url = `${CLIENT_API_URL}/admin/${payerId}/referral_route_check`;
    return fmhAPI.base.url(url).post(params).json();
}

/** Resend supplier or prescriber fax */
export async function sendFax({ referralDetails, performanceEntries, faxType, reason, source }) {
    const url = `${CLIENT_API_URL}/admin/${referralDetails?.payerId}/referrals/${referralDetails?.referralId}/resend-fax?fax_type=${faxType}`;
    return fmhAPI.base
        .url(url)
        .post({
            performanceEntries,
            reason,
            source,
        })
        .json();
}
